import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '../button/button.module';

import { UserAvatarComponent } from './user-avatar.component';


@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
  ],
  declarations: [
    UserAvatarComponent,
  ],
  exports: [
    UserAvatarComponent,
   ],
  providers: []
})
export class UserAvatarModule { }
